import { Grid } from '@mui/material';

import { ContainerColumnLeft } from '@occc-app/design-system';
import { InfoField, CardLayout } from '@occc/ui-design-system';
import { AudienceExternalIdentityVerificationTargetingAttributeFragment } from '@occc/graphql';

export const ExternalIdentityVerificationDetails = ({
  items,
}: {
  items: AudienceExternalIdentityVerificationTargetingAttributeFragment[];
}) => {
  if (!items.length) return null;

  return (
    <ContainerColumnLeft>
      <CardLayout title='External identity verification'>
        {items.map(({ provider, identityVerificationOperator, verificationAttributes }) => {
          const attributes = verificationAttributes?.join(', ');
          return (
            <Grid
              container
              spacing={3}
              key={`${provider}-${identityVerificationOperator}-${attributes}`}
            >
              <Grid item xs={12} sm={6} md={4}>
                <InfoField label='Provider' value={provider} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField label='Operator' value={identityVerificationOperator} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField label='Verification attributes' value={attributes} />
              </Grid>
            </Grid>
          );
        })}
      </CardLayout>
    </ContainerColumnLeft>
  );
};
